import React, { useEffect, useState } from "react";
import CustomSelect from "../form/CustomSelect";
import { GetUserRoles } from "../../api/users/getUserRoles";
import { useTranslation } from "react-i18next";

// Legacy (non-iip_user) roles, assigned by writing users.role. Kept for
// backwards compatibility so editing a legacy user still works.
const LEGACY_ROLES = [
  { value: "admin", label: "Admin", name: "admin" },
  { value: "client_admin", label: "Client Admin", name: "client_admin" },
  { value: "office_admin", label: "Office Admin", name: "office_admin" },
  { value: "agent", label: "Agent", name: "agent" },
];

// `legacy` picks the source: static legacy roles (value = role name) vs the
// company's dynamic custom roles (value = role id). Everything else is identical.
const RoleSelect = ({ legacy, value, onChange }) => {
  const { t } = useTranslation();
  const [availableRoles, setAvailableRoles] = useState(
    legacy ? LEGACY_ROLES : []
  );

  useEffect(() => {
    if (legacy) {
      setAvailableRoles(LEGACY_ROLES);
      return;
    }
    const setRoles = async () => {
      try {
        setAvailableRoles(await GetUserRoles());
      } catch (err) {
        console.log("Error fetching user roles: " + err);
      }
    };
    setRoles();
  }, [legacy]);

  return (
    <CustomSelect
      placeholder={<div>{t("Select user role")}</div>}
      options={availableRoles}
      onChange={onChange}
      value={
        availableRoles.find((o) => String(o.value) === String(value)) || null
      }
    />
  );
};

export default RoleSelect;
